var map = {
	"./pr-1.png": "d5b7",
	"./pr-2.png": "8929",
	"./pr-3.png": "ee86",
	"./pr-4.png": "6843",
	"./pr-5.png": "005c2",
	"./pr-6.png": "bb63",
	"./pr-7.png": "1f0e",
	"./pr-8.png": "126b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7e5";